module.exports = require("./sq.d.ts");